import { useEffect, useState } from 'react';
import api from '../services/api.js';

const when = (ts) =>
  ts ? new Date(ts).toLocaleString('en-US', { timeZone: 'Asia/Manila', month: 'short', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';

/** Record of tug machinery breakdowns: open ones first, then history.
 * `refreshKey` changes whenever the page logs or closes a maintenance window. */
export default function BreakdownLog({ refreshKey }) {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  useEffect(() => {
    let current = true;
    api
      .getBreakdownLog()
      .then((d) => current && setRows(d || []))
      .catch((e) => current && setError(e.message || 'Failed to load the breakdown log.'));
    return () => {
      current = false;
    };
  }, [refreshKey]);
  return (
    <div className="card border-0 shadow-sm" data-testid="breakdown-log">
      <div className="card-header bg-white pt-3 border-bottom-0">
        <h6 className="mb-0 fw-bold text-uppercase small text-secondary">Machinery Breakdown Log</h6>
      </div>
      <div className="card-body table-responsive">
        {error && <div className="alert alert-danger">{error}</div>}
        {rows.length === 0 ? (
          <p className="text-muted small mb-0" data-testid="no-breakdowns">No machinery breakdowns recorded.</p>
        ) : (
          <table className="table table-sm align-middle small mb-0">
            <thead>
              <tr><th>Tug</th><th>Machinery</th><th>Start of breakdown</th><th>Cause</th><th>Back to normal</th><th className="text-end">Days</th><th>Notes</th></tr>
            </thead>
            <tbody>
              {rows.map((b) => (
                <tr key={b.id} data-testid="breakdown-row" data-tug={b.tugName} data-open={b.open}>
                  <td className="fw-bold">{b.tugName}</td>
                  <td>{b.machinery || '—'}</td>
                  <td>{when(b.startedAt)}</td>
                  <td>{b.cause || '—'}</td>
                  <td>{b.open ? <span className="badge bg-danger">Under repair</span> : when(b.backToNormalAt)}</td>
                  <td className="text-end">{b.daysUnderRepair}</td>
                  <td className="text-muted">{b.notes || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
